// Device-scoped analytics opt-out flag. Stored in localStorage so it's readable
// synchronously at boot — Firebase Analytics initializes before auth resolves, so the
// choice can't wait on Firestore. Mirrors the theme preference's localStorage pattern
// (store/theme/ThemeContext). The Firestore mirror (users/{uid}/preferences/privacy)
// that carries the choice across devices is owned by AnalyticsConsentContext.
export const ANALYTICS_OPT_OUT_KEY = 'parsley-analytics-opt-out'

export function getStoredAnalyticsOptOut(): boolean {
  return localStorage.getItem(ANALYTICS_OPT_OUT_KEY) === 'true'
}

export function setStoredAnalyticsOptOut(optedOut: boolean): void {
  if (optedOut) {
    localStorage.setItem(ANALYTICS_OPT_OUT_KEY, 'true')
  } else {
    localStorage.removeItem(ANALYTICS_OPT_OUT_KEY)
  }
}
